<div class="manual-shell">
  <section class="hero-card">
    <div class="hero-copy">
      <div class="hero-kicker">
        <span class="hero-kicker-badge">
          <lucide-icon [img]="FileTextIcon" [size]="18"></lucide-icon>
        </span>
        User Manual Prototype
      </div>
      <h1>Operate the Bilateral Trading Portal with a clear day-to-day flow.</h1>
      <p>
        This prototype turns the written manual into a quick in-product guide so new users can understand what to open,
        in what order, and why each module matters.
      </p>
      <div class="hero-actions">
        <a class="hero-btn hero-btn-primary" routerLink="/">Go to Dashboard</a>
        <a class="hero-btn hero-btn-secondary" routerLink="/applications">Start with Applications</a>
      </div>
    </div>

    <div class="hero-panel">
      <h2>Best Starting Sequence</h2>
      <div class="hero-sequence">
        <span>Vendors</span>
        <span>Documents</span>
        <span>LOAs</span>
        <span>Contracts</span>
        <span>Applications</span>
        <span>Billing</span>
      </div>
      <p>Following this order prevents missing master data, broken record links, and approval delays later.</p>
    </div>
  </section>

  <section class="section-card">
    <div class="section-heading">
      <div>
        <p class="section-label">Workflow</p>
        <h2>Recommended business process</h2>
      </div>
      <p class="section-note">Use this as the onboarding walkthrough for staff users.</p>
    </div>

    <div class="workflow-grid">
      @for (step of workflow; track step.title) {
        <article class="workflow-card">
          <h3>{{ step.title }}</h3>
          <p>{{ step.summary }}</p>
          <a class="inline-link" [routerLink]="step.route">{{ step.cta }}</a>
        </article>
      }
    </div>
  </section>

  <section class="section-card">
    <div class="section-heading">
      <div>
        <p class="section-label">Modules</p>
        <h2>What each area is used for</h2>
      </div>
      <p class="section-note">Keep this section open during demos or new-user training.</p>
    </div>

    <div class="module-grid">
      @for (module of modules; track module.title) {
        <article class="module-card">
          <div class="module-head">
            <span class="module-icon">
              <lucide-icon [img]="$any(module.icon)" [size]="18"></lucide-icon>
            </span>
            <div>
              <h3>{{ module.title }}</h3>
              <p>{{ module.summary }}</p>
            </div>
          </div>
          <div class="pill-row">
            @for (highlight of module.highlights; track highlight) {
              <span class="pill">{{ highlight }}</span>
            }
          </div>
          <a class="inline-link" [routerLink]="module.route">{{ module.routeLabel }}</a>
        </article>
      }
    </div>
  </section>

  <section class="double-grid">
    <article class="section-card compact">
      <div class="section-heading">
        <div>
          <p class="section-label">Roles</p>
          <h2>Who should do what</h2>
        </div>
      </div>

      <div class="role-grid">
        @for (role of roleGuides; track role.title) {
          <div class="role-card">
            <h3>{{ role.title }}</h3>
            <p>{{ role.summary }}</p>
            <ul>
              @for (item of role.checklist; track item) {
                <li>{{ item }}</li>
              }
            </ul>
          </div>
        }
      </div>
    </article>

    <article class="section-card compact">
      <div class="section-heading">
        <div>
          <p class="section-label">Daily Use</p>
          <h2>Short operating checklist</h2>
        </div>
      </div>

      <div class="checklist-card">
        <div class="checklist-row" *ngFor="let item of dailyChecklist; let index = index">
          <span class="check-index">{{ index + 1 }}</span>
          <span>{{ item }}</span>
        </div>
      </div>
    </article>
  </section>

  <section class="section-card alert-card">
    <div class="alert-head">
      <span class="alert-icon">
        <lucide-icon [img]="TriangleAlertIcon" [size]="18"></lucide-icon>
      </span>
      <div>
        <h2>When a workflow gets blocked</h2>
        <p>
          Capture the module name, record number, action attempted, and any error message before escalating to support.
          That information usually shortens the resolution cycle.
        </p>
      </div>
    </div>
  </section>
</div>
